<template>
    <div class="container px-4 mx-auto pt-4">
        <slot />
    </div>
</template>
